export default __webpack_public_path__ + "static/media/Add_User.d952b508.svg";